export * from 'html-jsx';
import { createProps, updateProps } from './props';
export { createProps, updateProps };
const anchor = new Comment();
export const Fragment = Symbol();
export const jsx = (kind, props, key)=>kind === Fragment ? props.children : {
        kind,
        props,
        key
    }
;
export const jsxs = jsx;
export let hook;
const createHook = ()=>function current(fn = current.fn) {
        const prev = hook;
        hook = current;
        hook.fn = fn;
        fn();
        hook = prev;
    }
;
let Chunk = class Chunk extends Array {
    firstChild;
    dom = [];
    get last() {
        return this.dom.at(-1);
    }
    get nextSibling() {
        return this.last?.nextSibling;
    }
    // insertBefore(x: any) {
    //   this.unshift(x)
    // }
    appendChild(x) {
        this.push(x);
    }
    after(x) {
        this.last?.after(x);
    }
    save() {
        this.dom = [
            ...this
        ];
    }
    remove() {
        this.dom.forEach((el)=>el.remove()
        );
        this.splice(0);
    }
    removeChild(x) {
        const i = this.indexOf(x);
        ~i && this.splice(i, 1);
    // i = this.dom.indexOf(x)
    // ~i && this.dom.splice(i, 1)
    }
};
const { TEXT_NODE , COMMENT_NODE  } = document;
export const html = document.createElement.bind(document);
export const svg = document.createElementNS.bind(document, 'http://www.w3.org/2000/svg');
const forceArray = (x, withNull)=>Array.isArray(x) ? withNull && !x.length ? [
        null
    ] : x : x == null && !withNull ? [] : [
        x
    ]
;
const flatDom = (arr, res = [])=>{
    for (const el of arr){
        if (el.dom) res.push(...flatDom(el.dom));
        else res.push(el);
    }
    return res;
};
const prevs = new WeakMap();
export const render = (n, el, doc = html, withNull = false)=>reconcile(el, forceArray(n, withNull), prevs.get(el), doc)
;
const reconcile = (parent, nk, pk, doc)=>{
    if (pk?.running) {
        console.warn('attempt to reconcile lane which is reconciling');
        return;
    }
    if (pk === nk) nk = [
        ...nk
    ];
    prevs.set(parent, nk);
    nk.running = true;
    nk.dom = Array(nk.length);
    nk.keyed = new Map();
    nk.mapped = new Map();
    if (Array.isArray(pk)) {
        const keep = new Set();
        for(let i = 0, n, el, p, pel, k, pi; i < nk.length; i++){
            n = nk[pi = i];
            k = n?.key;
            if (k != null) {
                nk.keyed.set(k, i);
                pi = pk.keyed.get(k) ?? -1;
            }
            p = pk[pi];
            pel = pk.dom[pi];
            nk.dom[i] = el = create(doc, n, p, pel);
            if (el === pel) keep.add(pel);
        }
        for (const pel1 of pk.dom){
            if (!keep.has(pel1)) {
                if (parent instanceof Chunk) parent.removeChild(pel1);
                pel1.remove();
                pk.mapped.get(pel1)?.hook?.onremove?.();
            }
        }
    } else {
        for(let i = 0, n, el, k; i < nk.length; i++){
            n = nk[i];
            k = n?.key;
            if (k != null) nk.keyed.set(k, i);
            nk.dom[i] = el = create(doc, n);
            nk.mapped.set(el, n);
        }
    }
    nk.flatDom = flatDom(nk.dom);
    if (pk?.flatDom) diff(parent, nk.flatDom, pk.flatDom);
    else nk.flatDom.forEach((el)=>parent.appendChild(el)
    );
    nk.running = false;
};
const diff = (parent, n, p, i = 0, len = n.length, el, last)=>{
    if (parent instanceof Chunk) {
        // parent.splice(0) // , parent.length, ...n)
        // TODO: optimize this
        for(; i < len; i++){
            el = n[i];
            if (i < parent.length) {
                if (p[i] === el) continue;
                parent[i] = el;
            } else {
                parent.push(el);
            }
        }
        let d = parent.length - len;
        while(d--)parent.pop();
    } else {
        for(; i < len; i++){
            el = n[i];
            if (p[i] === el) last = el;
            else if (!i) parent.insertBefore(last = el, parent.firstChild);
            else last.after(last = el);
        }
    }
};
const create = (doc, n, p, pel)=>{
    let el;
    switch(typeof n){
        case 'string':
        case 'number':
            if (pel?.nodeType === TEXT_NODE) {
                if (p != n) pel.nodeValue = n;
                return pel;
            }
            el = new Text(n);
            return el;
        case 'object':
            if (!n) break;
            if (Array.isArray(n)) {
                if (pel && Array.isArray(p)) el = pel;
                else el = new Chunk();
                reconcile(el, n, p, doc);
                el.save();
            } else if (typeof n.kind === 'string') {
                // maybe switch to svg namespace
                if (n.kind === 'svg') doc = svg;
                if (n.props.ref?.current && n.props.ref.current.tagName.toLowerCase() === n.kind && (el = n.props.ref.current) || // if the previous element is of the same kind, use that
                pel && p?.kind === n.kind && (el = pel)) {
                    // only update props if we have the element
                    updateProps(doc, el, n.kind, n.props);
                } else {
                    // otherwise create an element and props
                    el = doc(n.kind, 'is' in n.props ? {
                        is: n.props.is
                    } : void 0);
                    createProps(doc, el, n.kind, n.props);
                }
                // maybe switch to xhtml namespace
                if (n.kind === 'foreignObject') doc = html;
                // render children
                render(n.props.children, el, doc);
                // scheduling to prevent triggering ref effects before this render finishes
                // TODO: has to be put in a proper queue instead of relying on the microtask
                if ('ref' in n.props && el !== n.props.ref.current) queueMicrotask(()=>n.props.ref.current = el
                );
            } else {
                let initial = true;
                if (!((el = pel) && (n.hook = p.hook))) {
                    el = new Chunk();
                    n.hook = createHook();
                }
                let prevDom;
                let nextDom;
                n.hook(()=>{
                    let next;
                    if (!initial && !(next = el.nextSibling)) el.after(next = anchor);
                    render(n.kind(n.props), el, doc, true);
                    el.save();
                    if (!initial && next) {
                        nextDom = flatDom(el);
                        if (prevDom?.length > 0) {
                            for(let i = 0, e; i < nextDom.length; i++){
                                e = nextDom[i];
                                if (prevDom[i] !== e) next.before(e);
                            }
                        } else {
                            for (const e of nextDom)next.before(e);
                        }
                        prevDom = nextDom;
                        next === anchor && next.remove();
                    } else {
                        initial = false;
                    }
                });
            }
            return el;
    }
    if (pel?.nodeType === COMMENT_NODE) return pel;
    el = new Comment();
    return el;
};
